export enum Stack {
  dev,
  pie,
  stage,
  prod
}
